import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

import { ROUTES } from "@/enums/routes";

import Branches from "@/components/Organization/Branch/Branches";
import ProtectedRoute from "@/components/ProtectedRoute";

import Dashboard from "@/components/Organization/Dashboard";
import Categories from "@/components/Organization/Category/Categories";
import ForgotPassword from "@/components/Authentication/ForgotPassword";

import Login from "@/pages/Login";

import MainLayout from "@/components/SIdebar/MainLayout";
import Members from "@/components/Organization/Members/Members";

import UpdateExpense from "@/components/Organization/Expense/UpdateExpense";
import AddExpense from "@/components/Organization/Expense/AddExpense";

import { SignUp } from "./pages/SignUp";
import ResetPassword from "@/components/Authentication/ResetPassword";

import ExportPdf from "./components/Organization/Expense/ExportPdf";
import { SentInvitations } from "./components/Organization/Members/SentInvitations";
import { setNavigator } from "./utils/navigationHelper";
import NotFoundPage from "./components/NotFoundPage";
import { OrganizationForm } from "./components/OrganizationForm";
import Profile from "./components/Authentication/Profile";
import Item from "@/components/Organization/Item/Items";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);
  return (
    <div className="min-h-screen max-h-[100dvh] overflow-auto">
      <Routes>
        <Route path={ROUTES.LOGIN} element={<Login />} />
        <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route path={`${ROUTES.SIGNUP}/:token/signup`} element={<SignUp />} />
        <Route
          path={`${ROUTES.CREATE_PASSWORD}/:uid/:token`}
          element={<ResetPassword />}
        />
        <Route path={ROUTES.NOTFOUND} element={<NotFoundPage />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
            <Route path={ROUTES.CATEGORIES} element={<Categories />} />
            <Route path={ROUTES.ADDEXPENSE} element={<AddExpense />} />
            <Route path={ROUTES.EXPORT_PDF} element={<ExportPdf />} />
            <Route path={ROUTES.ITEMS} element={<Item />} />
            <Route path={ROUTES.BRANCHES} element={<Branches />} />
            <Route
              path={ROUTES.ORGANIZATION_FORM}
              element={<OrganizationForm />}
            />

            <Route path={ROUTES.MEMBERS} element={<Members />} />
            <Route path={ROUTES.INVITATIONS} element={<SentInvitations />} />

            <Route
              path={`${ROUTES.UPDATE_EXPENSE}/:id`}
              element={<UpdateExpense />}
            />
            <Route path={ROUTES.PROFILE} element={<Profile />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
